export default __webpack_public_path__ + "static/media/5.41a050bb.png";